import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const ADMIN_BASE = `${BASE}/api/admin`;

export const adminApi = axios.create({
  baseURL: ADMIN_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Optional bearer token (used for query-string-friendly endpoints like PDF preview)
const TOKEN_KEY = "geniex_admin_token";

export function setStoredToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

adminApi.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function pdfUrl(qid) {
  const t = getStoredToken();
  const q = t ? `?token=${encodeURIComponent(t)}` : "";
  return `${ADMIN_BASE}/quotations/${qid}/pdf${q}`;
}

export function exportUrl(entity, fmt) {
  return `${ADMIN_BASE}/export/${entity}.${fmt}`;
}

export function absoluteAdminUrl(relPath) {
  if (!relPath) return "";
  if (relPath.startsWith("http")) return relPath;
  return `${BASE}${relPath}`;
}
